import { Skeleton, Stack } from '@mui/material'

export const LoadingSkeletons = ({ length }: { length: number }) => {
  return (
    <Stack gap={2} alignItems="center" justifyContent="center">
      {Array.from({ length }, (_, i) => i).map((index) => (
        <Skeleton key={index} width="100%" height={40} variant="rectangular" />
      ))}
    </Stack>
  )
}
